module.exports = __webpack_public_path__ + "img/vip-guarantee-fee-background.238451b4.png";